import {
  defineNuxtRouteMiddleware,
  useNuxtApp,
  navigateTo,
  type RouteMiddleware
} from 'nuxt/app'
import ORGANIZATION_THINGS from '~/queries/things.gql'

export const handleIndexRedirect: RouteMiddleware = async (to) => {
  const nuxtApp = useNuxtApp()
  const { $auth, $store, $apolloProvider } = nuxtApp

  if (!$auth.loggedIn) return

  if (to.name !== 'index') return

  if (
    $store.getters['user/isServicePartner'] ||
    $store.getters['user/isInternal']
  ) {
    const { data } =
      (await $apolloProvider?.defaultClient.query({
        query: ORGANIZATION_THINGS,
        fetchPolicy: 'cache-first'
      })) ?? {}
    if (!data?.orgData?.things?.length) {
      return navigateTo('/news')
    }
  }

  return navigateTo('/dashboard')
}

export default defineNuxtRouteMiddleware(handleIndexRedirect)
